/* eslint-disable no-unused-vars */
import { Avatar, Box, Flex, Typography } from "../../../ppui";
import { formatIndianCurrency } from "../../../utils/common";
export const SalaryHeaders = (currentPage, rowsPerPage) => [
  {
    key: "salary_id",
    label: "SL No.",
    isShortable: true,
    isVisible: true,
    // getValue: (row, index) => (index + 1)
    getValue: (row, index) => currentPage * rowsPerPage + index + 1,
  },
  {
    key: "employee_name",
    label: "Employee Name",
    align: "left",
    isClickable: true,
    isShortable: false,
    isVisible: true,
    isColumnSticky: "true",
    getValue: (rows) => (
      <>
        <Flex alignItems="center">
          <Avatar
            className={"avatarHover"}
            size="sm"
            color="secondary"
            initials={`${rows.employee_name.trim().substring(0, 1).toUpperCase()}`} // Join the initials with a dot
            sx={{ marginInlineEnd: "0.625rem" }}
          />
          <Box>
            {rows.employee_name}
            <Typography
              color={"default"}
              colorVariant={"light"}
              variant={"body2"}
              mb={"0"}
            >
              #{rows.employee_code}
            </Typography>
          </Box>
        </Flex>
      </>
    ),
  },
  {
    key: "age",
    label: "Age As Per This Month",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => row?.employees?.age ? row?.employees?.age : "--",
  },
  // {
  //   key: "employee_code",
  //   label: "Employee Code",
  //   align: "left",
  //   isShortable: false,
  //   isVisible: true,
  //   getValue: (row, index) => row?.employees?.employee_code? row?.employees?.employee_code : "00",
  // },
  {
    key: "esi_insurance_no",
    label: "IP/ESI NO",
    isShortable: false,
    isVisible: true,
    // isColumnSticky: "true",
    getValue: (row) =>
      row?.employees?.esi_insurance_no
        ? row?.employees?.esi_insurance_no
        : "--",
  },
  // {
  //   key: "uan_no",
  //   label: "UAN No.",
  //   isShortable: false,
  //   isVisible: true,
  //   getValue: (row, index) => row?.employees?.uan_no ? row?.employees?.uan_no : "00",
  // },
  {
    key: "payable_days",
    label: "Payable Days",
    align: "left",
    isShortable: false,
    isVisible: true,
  },
  {
    key: "gross_salary",
    label: "Gross Pay",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => (row?.gross_salary ? formatIndianCurrency(row?.gross_salary.toFixed()) : "00"),
  },
  {
    key: "esi_wages",
    label: "ESI Wages",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row, index) => (row?.esi_wages ? formatIndianCurrency(row?.esi_wages.toFixed()) : "00"),
  },

  // {
  //   key: "remarks",
  //   label: "EDLI Wages",
  //   align: "right",
  //   isShortable: false,
  //   isVisible: true,
  // },
  {
    key: "esi_amount",
    label: "Employee Contribution",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => (row?.esi_amount ? formatIndianCurrency(row?.esi_amount.toFixed()) : "00"),
  },
  {
    key: "ee_esi_amount",
    label: "Employer Contribution",
    align: "right",
    isShortable: false,
    isVisible: true,
    getValue: (row) => (row?.ee_esi_amount ?  formatIndianCurrency(row?.ee_esi_amount.toFixed()) : "00"),
  },


  {
    key: "remarks",
    label: "Remarks",
    align: "left",
    isShortable: false,
    isVisible: true,
    getValue: (row) => {
      const joinDate = row?.employees?.join_date ? new Date(row.employees.join_date) : null;
      const exitDate = row?.employees?.exit_formalities?.[0]?.exit_date ? new Date(row?.employees?.exit_formalities?.[0]?.exit_date) : null;
      const recordMonth = row?.month;  
      const recordYear = row?.year;   
      if (joinDate && joinDate.getMonth() + 1 === recordMonth && joinDate.getFullYear() === recordYear) {
        return `The Employee joined on ${joinDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      if (exitDate && exitDate.getMonth() + 1 === recordMonth && exitDate.getFullYear() === recordYear) {
        return `Employee exited at ${exitDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`;
      }
      return row?.remarks || "--";
    }
  },
];

// export const SalaryRows = [
//   {
//     slNo: 1,
//     employeeName: "Barun Sharma",
//     uan: "1234567890",
//     epfWages: "1500",
//     eeContribution: "2000",
//     remarks: "N/A",
//     age: "26",
//   },

// ];
